import { supabase } from './supabase';

/**
 * Call Supabase edge function proxy for recreation.gov APIs
 * @param {string} target - The API target ('recreation', 'campsites', 'facilities', etc.)
 * @param {object} params - Query parameters
 * @param {string} endpoint - Optional custom endpoint URL
 * @returns {Promise<object>} API response data
 */
export const callSupabaseProxy = async (target, params = {}, endpoint = null) => {
  try {
    const { data, error } = await supabase.functions.invoke('proxy', {
      body: {
        target,
        params,
        method: 'GET',
        endpoint,
      },
    });

    if (error) {
      throw new Error(`Supabase proxy error: ${error.message}`);
    }

    return data?.data || data;
  } catch (err) {
    console.error('Supabase proxy call failed:', err);
    throw err;
  }
};

/**
 * Fetch campsites from recreation.gov via Supabase
 */
export const fetchCampsites = async (limit = 50, offset = 0) => {
  return callSupabaseProxy('recreation', {
    limit: limit.toString(),
    offset: offset.toString(),
  });
};

/**
 * Fetch recreation areas from recreation.gov via Supabase
 */
export const fetchRecAreas = async (recAreaId) => {
  const endpoint = `https://ridb.recreation.gov/api/v1/recareas/${recAreaId}`;
  return callSupabaseProxy('recreation', {}, endpoint);
};

/**
 * Fetch facilities from recreation.gov via Supabase
 */
export const fetchFacilities = async (limit = 50, offset = 0) => {
  return callSupabaseProxy('recreation', {
    limit: limit.toString(),
    offset: offset.toString(),
  }, 'https://ridb.recreation.gov/api/v1/facilities');
};
